import { defineComponent as _defineComponent } from 'vue'
import imageApi from "@/api/image";
import queue from "@/store/quque";
import { chapterInfoType } from "@/type/chapter";
import { ref, onMounted } from "vue";
import usePosterStore from '@/store/poster';

type chapterItemType = chapterInfoType & { blob: string; chapterCover: string; pageImage: string; };

const __default__ = { name: 'manga-chapter-item' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: ['chapterInfo', 'bookmark', 'viewType'],
  setup(__props, { expose: __expose }) {
  __expose();

const poster: any = usePosterStore();
const props = __props;
const placeholder = require("@/assets/s-blue.png");
const fit = 'cover';
let blobLink = ref('');
const chapterName = ref(props.chapterInfo.chapterName);
let viewType = ref(props.chapterInfo.viewType);

onMounted(() => {
	queue.mangaQueue.add(() => get_poster(props.chapterInfo));
})

async function get_poster(item: chapterItemType) {
	const coverName = item.pageImage || item.chapterCover;
	if (poster[coverName]) {
		blobLink.value = poster[coverName]
	} else {
		blobLink.value = await imageApi.get(coverName);
		poster[coverName] = blobLink.value;
	}
}


const __returned__ = { poster, props, placeholder, fit, get blobLink() { return blobLink }, set blobLink(v) { blobLink = v }, chapterName, get viewType() { return viewType }, set viewType(v) { viewType = v }, get_poster }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})